<template>
  <div class="main-container">
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table ref="selection" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="version">
          <span class="table-btn" @click="openFile(row)">{{ row.version }}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="download(row)">下载</span>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        :page-size-opts="[10, 20, 30, 50, 100]"
        @on-page-size-change="pageSizeChange"
        style="text-align: center"
      />
    </div>
    <!-- pdf预览 -->
    <pdf-view ref="pdfView" />
  </div>
</template>
<script>
import { pageTool, common } from '@/api/mixins';
import pdfView from '@/components/commons/pdfView';
export default {
  mixins: [pageTool, common],
  components: {pdfView},
  data: () => ({
    columns: [
      {
        title: '版本名称',
        slot: 'version',
        minWidth: 100,
        align: 'center'
      },
      {
        title: '更新内容',
        key: 'content',
        minWidth: 100,
        align: 'center'
      },
      {
        title: '发布日期',
        key: 'createTime',
        align: 'center',
        width: 160,
        render: (h, params) => {
          if (params.row.createTime) {
            return h('div', params.row.createTime.split(' ')[0]);
          }
        }
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 150,
        fixed: 'right'
      }
    ],
    allData: {}
  }),
  created() {
    this.initListParams('/buz/reservationTemplate/read/list');
  },
  activated() {
    this.getList();
  },
  methods: {
    // 打开文件
    openFile(row) {
      const list = JSON.parse(row.fileJson);
      if(!list || !list.length) {
        this.$notice.error('暂无下载链接');
        return;
      }
      this.$refs.pdfView.open(list);
    },
    // 下载
    download(row) {
      const list = JSON.parse(row.fileJson);
      if (!list || !list.length) return;
      if(list.length == 1) {
        this.$units.downloadFun({ url: list[0].path });
      }else{
        this.$units.downloadFun({ 
          url: '/buz/reservationTemplate/downAll',
          params: {
            id: row.id,
          } 
        });
      }
    },
  }
};
</script>
<style lang='scss' scoped>
</style>